// Tabelle der Nachweiskette — geteilt von der Chef-Sicht (/protokoll) und der Betreiber-Globalsicht
// (/admin/audit). Diskriminierte Props: `withWorkshop` koppelt die Werkstatt-Spalte an den Admin-Typ
// (Review-Fund 16.07.: ein Partial-Pick machte die Spalten in BEIDEN Sichten optional und trug keine
// Invariante mehr). Zeitpunkte MIT Sekunden — mehrere Aktionen derselben Minute müssen ordnbar bleiben.
import type { AdminAuditEntryDTO, AuditEntryDTO } from '@wf/shared'
import { parseDbTimestamp } from '@wf/shared'
import { formatDateTimeDE } from '../time/format'
import { actionLabel } from './actionLabels'
import { actorLabel } from './auditCsv'

type Props =
  | { entries: readonly AuditEntryDTO[]; withWorkshop?: false }
  | { entries: readonly AdminAuditEntryDTO[]; withWorkshop: true }

export function AuditTable(props: Props) {
  if (props.entries.length === 0) {
    return (
      <div className="wf-empty">
        <div className="wf-empty__title">Keine Einträge</div>
        <div className="wf-empty__text">Im gewählten Zeitraum wurde nichts protokolliert.</div>
      </div>
    )
  }
  return (
    <div className="wf-table" aria-label="Protokoll">
      <div className="wf-table__head">
        <span className="wf-audcol wf-audcol--zeit">Zeitpunkt</span>
        {props.withWorkshop ? <span className="wf-audcol">Werkstatt</span> : null}
        <span className="wf-audcol wf-audcol--aktion">Aktion</span>
        <span className="wf-audcol">Akteur</span>
        <span className="wf-audcol">Ziel</span>
        <span className="wf-audcol wf-audcol--detail">Detail</span>
      </div>
      {props.entries.map((e) => (
        <div key={e.id} className="wf-table__row wf-audrow">
          <span className="wf-audcol wf-audcol--zeit wf-mono">{formatDateTimeDE(parseDbTimestamp(e.ts))}</span>
          {props.withWorkshop ? (
            <span className="wf-audcol">
              {(e as AdminAuditEntryDTO).workshopName ??
                ((e as AdminAuditEntryDTO).workshopId != null ? `Werkstatt #${(e as AdminAuditEntryDTO).workshopId}` : 'Plattform')}
            </span>
          ) : null}
          <span className="wf-audcol wf-audcol--aktion">
            {actionLabel(e.action)}
            <span className="wf-audrow__code">{e.action}</span>
          </span>
          <span className="wf-audcol">{actorLabel(e)}</span>
          <span className="wf-audcol wf-mono">{e.targetType ? `${e.targetType} #${e.targetId ?? '–'}` : '–'}</span>
          <span className="wf-audcol wf-audcol--detail" title={e.detail ?? undefined}>
            {e.detail ?? '–'}
          </span>
        </div>
      ))}
    </div>
  )
}
